import { Environment, EnvironmentSequence } from '../../../Environment';
import GameManager from '../../../GameManager';
import React from 'react';
import { VideoSegment } from '../../../Scenario/VideoSegment';
import $ from 'jquery'
import ReactCaption from '../../general/react/ReactCaption';
import { ClosedCaptionManager } from '../../../ClosedCaptionManager';
import Tools from '../../../Misc/Tools';
import { Chapter, ChapterManager } from '../../../ChapterManager';
import { Plugins } from '@capacitor/core';
import './VideoEnvironment.css'
// import 'get-available-memory';
// const { GetAvailableMemory } = Plugins;

export default class VideoEnvironment extends Environment<VideoEnvironmentProps> {
	public static currentPart= 1;
	public static currentVideo = 1;
	public static videoAssets: string[] = [];
	private onMemoryUpdated: (memory: string) => void;
	/**
	 * Keeps track of timeout used to know when to pause the video
	 */
	private _playTimeout: any;

	public ccManager: ClosedCaptionManager = new ClosedCaptionManager();

	/**
	 * The current video segment that is being played
	 */
	private _currentVideo: any;
	private _currentSequence: EnvironmentSequence<VideoSequence>
	/**
	 * Keeps track of the interval used to check if all videos have finished loading
	 */
	private _checkForCompletionInterval: any;

	/**
	 * ctor
	 * @param gameManager An instance of the game manager
	 */
	constructor(gameManager: GameManager, private dispatch: any) {
		super(gameManager);
		this._playTimeout = null;
	}

	/**
	 * Gets the default properties of the video. If any of the fields are not set up through the public properties, these values get used
	 */
	public getDefaultProps(): VideoEnvironmentProps {
		return {
			controls: false,
			isDirty: false,
			onPartsLoaded: null,
			part: null,
			muted: false,
			autoBlur: false
		}
	}

	/**
	 * Initializes the video player. This must be called before anything
	 */
	 public init(): void {
		this.markReady();
	}

	public blurFadeIn(): void {
		var blurEl = document.getElementById('blur-item');
		blurEl.classList.remove('vid-fadeOut')
		blurEl.classList.add('vid-fadeIn')
	}

	public blurFadeOut(): void {
		var blurEl = document.getElementById('blur-item');
		blurEl.classList.remove('vid-fadeIn')
		blurEl.classList.add('vid-fadeOut')
	}

	/**
	 * Plays a video sequence. Video sequences are expected to already be loaded before this method is called
	 * @param sequence An instance of the sequence to play
	 */
	public playSequence(sequence: EnvironmentSequence<VideoSequence>) {
		const context = this;
		if(context.props.autoBlur) {
			context.blurFadeOut();
		}
		
		setTimeout(() => {
			this._currentSequence = sequence;
			var videoResult = this.props.part;
			const onDone = () => {
				if(sequence.props.loop) {
					clearTimeout(context._playTimeout);
					context._playTimeout = undefined;
					context.playSequence(sequence)

					if(sequence.onDone) {
						sequence.onDone('');
					}
				} else {
					context.pauseCurrentSequence();
					context._playTimeout = undefined;

					if (sequence.onDone) {
						sequence.onDone('');
					}
				}
			};

			if (context._playTimeout) {
				clearTimeout(context._playTimeout);
				context._playTimeout = undefined;
			}

			if (!videoResult) {
				throw new Error('Video with the supplied properties could not be found. Be sure it has been loaded prior to playing it');
			}

			if (context._currentVideo) {
				$(context._currentVideo).css({
					display: 'none'
				});
				context._currentVideo = undefined;
			}
			
			var currentVideoAndChapter = VideoPart.currentVideoAndChapter(videoResult);
			context._currentVideo = currentVideoAndChapter.videoReferenceInDom;

			$(context._currentVideo).css({
				display: 'block'
			});


			currentVideoAndChapter.videoReferenceInDom.play().then(() => {
				(window as any)['areGraphicsRendering'] = true;
				currentVideoAndChapter.chapterManager.setChapter(sequence.props.chapterId);
				var start = currentVideoAndChapter.chapterManager.currentChapter.start;

				if (!start) {
					start = 0;
				}

				var end = currentVideoAndChapter.chapterManager.currentChapter.end;

				if (!end) {
					end = 0;
				}

				const length = (end - start) * 1000;
				currentVideoAndChapter.videoReferenceInDom.currentTime = start;
				console.log('Playing chapter ' + currentVideoAndChapter.chapterManager.currentChapter.id + ' for vide with url ' + currentVideoAndChapter.videoReferenceInDom.src);
				console.log('Stopping video in ' + length + 'milliseconds');
				context._playTimeout = setTimeout(() => {
					if(context.props.autoBlur) {
						context.blurFadeIn();
					}

					(window as any)['areGraphicsRendering'] = false;

					if(onDone) {
						onDone();
					}
				}, length);
				var vttPath = currentVideoAndChapter.videoReferenceInDom.src.slice(0, -3) + "vtt";
				this.ccManager.stopAll();
				this.ccManager.resume();
				this.ccManager.loadVtt(vttPath, Tools.generateGuid(), () => {
					this.dispatch({
						type: 'forceUpdate'
					});
				}, start * 1000);
			});
		}, 50);
	}

	/**
	 * Pauses the currently playing video
	 */
	public pauseCurrentSequence(): void {
		if (this._currentVideo) {
			if(this.props.autoBlur) {
				this.blurFadeIn();
			}
			(window as any)['areGraphicsRendering'] = false;

			this._currentVideo.pause();
			this.ccManager.pause();
		}
	}

	/**
	 * Renders the video player
	 */
	public render(onMemoryUpdated: (memory: string) => void, onForceUpdate: () => void, props: VideoRenderProperties) {
		this.onMemoryUpdated = onMemoryUpdated;
		if (!this.props) {
			return null;
		}

		//regereated render props and wait for all videos to load if public props changed
		if (this.props.isDirty) {
			if(this.props.isDirty) {
				this._refreshVideoRenderData();
			}
			this._checkForCompletion();
			this.props.isDirty = false;
		}
		var videoResult = this.props.part;
		var currentVideoAndChapter = VideoPart.currentVideoAndChapter(videoResult);
		if((window as any).setCCManager) {
			(window as any).setCCManager(this.ccManager)
		}
		return (
			<div id="core-video-environment"
				style={{
					width: '100%',
					height: '100%',
				}}>
				
				{/* {currentVideoAndChapter ? <video style={{
					width: '100%',
					height: '100%',
					display: 'none',
				}} src={currentVideoAndChapter.url} id={'single-video'} key={'single-video'} preload="auto" muted={this.props.muted} playsInline controls={this.props.controls}></video> : (null)} */}
				{videoResult.url.map((u: string, vi: number) => {
					return <video style={{
						width: '100%',
						height: '100%',
						display:  u === currentVideoAndChapter.url ? 'block' : 'none',
					}} src={u} id={'video-' + vi} key={'video-' + vi} preload="auto" muted={this.props.muted} playsInline controls={this.props.controls}></video>
				})}
				{/* {this.props.parts.map((v, index) => {
					return v.url.map((u: string, vi: number) => {
						//var enabled = v.enabled[vi];
						var url = u;
						return <video style={{
							width: '100%',
							height: '100%',
							display: 'none',
						}} src={url} id={'video-' + index + '-' + vi} key={'video-' + index + '-' + vi} preload="auto" muted={this.props.muted} playsInline controls={this.props.controls}></video>
					})
				})} */}
				{/* <ReactCaption
					currentCaption={this.ccManager.currentCaption}
					isPaused={this.ccManager.isPaused}
				></ReactCaption> */}
				{props.shouldShowDebugBttns() && this._currentVideo && !this._currentVideo.paused ? (
					<button style={{
						position: 'absolute',
			 			top: '10px',
						left: '300px',
						width: '100px',
						height: '100px',
						color: 'white',
						pointerEvents: 'all',
						zIndex: 100
					}} onClick={() => {	
						this.pauseCurrentSequence();
						clearTimeout(this._playTimeout);
						var videoResult = this.props.part;
						if(!videoResult) {
							throw Error('could not find video');
						}
						this._playTimeout = undefined;
						var currentVideoAndChapter =  VideoPart.currentVideoAndChapter(videoResult);

						currentVideoAndChapter.videoReferenceInDom.currentTime = currentVideoAndChapter.chapterManager.currentChapter.end;

						if(this._currentSequence.onDone) {
							this._currentSequence.onDone('');
						}
					}}>
						Skip Cutscene 
					</button>
				) : (null)}

				<div className='vid-blur-overlay' id='blur-item'></div>
			</div>
		);
	}

	/**
	 * Checks every so often for completion of all videos that are loading. This only runs while there are videos loading
	 */
	private _checkForCompletion() {
		var context = this;
		var stopInteval = () => {
			if (context._checkForCompletionInterval) {
				clearInterval(context._checkForCompletionInterval);
				this._checkForCompletionInterval = undefined;
			}
		}
		stopInteval();
		var $parent = $('#core-video-environment');
		var videoData = context.props.part;
		videoData.videoReferenceInDom = [];
		this._checkForCompletionInterval = setInterval(() => {
			if(!$parent.get(0)) {
				$parent = $('#core-video-environment');
			}
			var maxVideos = videoData.url.length;
			var currentlyLoadedVideos: boolean[] = [];
			
			for(var uIndx = 0; uIndx < videoData.url.length; uIndx++) {
				if(!videoData.videoReferenceInDom[uIndx]) {
					videoData.videoReferenceInDom[uIndx] = $parent.find('#video-' + uIndx).get(0);
				}
				var video = videoData.videoReferenceInDom[uIndx];

				if(VideoEnvironment.videoAssets.length <= uIndx) {
					VideoEnvironment.videoAssets.push('Loading ' + videoData.url[uIndx]);
				}

				if (video && (video.readyState === 1 || video.readyState === 4) && !currentlyLoadedVideos[uIndx]) {
					currentlyLoadedVideos[uIndx] = true;
					VideoEnvironment.videoAssets[uIndx] = 'Loaded ' + videoData.url[uIndx];
					const context = this;
					// GetAvailableMemory.getFreeMemory({}).then((r: any) => {
					// 	console.log('Memory queried. Result: ' + r);
					// 	context.onMemoryUpdated(r?.value);
					// });
				}
			}
			
			var areAllVideosLoaded = maxVideos === currentlyLoadedVideos.filter(c => c).length;
			var areAllChapterManagersLoaded = videoData.chapterManager.filter(cm => cm && cm.isLoaded).length === videoData.chapterManager.length;
			if (areAllChapterManagersLoaded && areAllVideosLoaded) {
				if (context.props.onPartsLoaded) {
					context.props.onPartsLoaded();
				}
				stopInteval();
			}
		}, 2000, this);
	}

	/**
	 * Refreshes video render data based on the newly obtained data
	 */
	private _refreshVideoRenderData() {
		var part = this.props.part;
		if(!part.chapterManager) {
			part.chapterManager = [];
		}
		for(var vidIndx = 0; vidIndx < part.url.length; vidIndx++) {
			var vid = part.url[vidIndx];
			part.chapterManager[vidIndx] = new ChapterManager();
			//http://gmsv3.com.s3.amazonaws.com/new-core-test/video%201.srt
			// var url = 'http://gmsv3.com.s3.amazonaws.com/new-core-test/';
			var srtPath = vid.slice(0, -3) + "srt";
			// var split = srtPath.split('/');
			// var fullUrl = url + split[split.length - 1];
			part.chapterManager[vidIndx].loadSrt(srtPath);
		} 
	}
}

/**
 * Describes a video sequence to play
 */
interface VideoSequence {
	/**
	 * The part id of the sequence to play
	 */
	partId: string;
	chapterId: string;

	loop?: boolean;
}

export interface VideoRenderProperties {
	updateWindow: any;
	shouldShowDebugBttns: () => boolean;
}

/**
 * All properties that can be passed to the environment
 */
export interface VideoEnvironmentProps {
	/**
	 * True to show video player controls (UI may vary by browser)
	 */
	controls?: boolean;
	muted?: boolean;
	part?: VideoPart;
	isDirty?: boolean;
	autoBlur?: boolean;
	onPartsLoaded?: () => void;
}

export class VideoPart {
	public partId: string = '';
	public url: string[] = [];
	public enabled?: boolean[] = [];
	public videoReferenceInDom?: any[];
	public chapterManager?: ChapterManager[] = []; 
	public static currentVideoAndChapter(part: VideoPart): {url: string, enabled: boolean; videoReferenceInDom: any; chapterManager: ChapterManager} {
		var indx = VideoEnvironment.currentVideo - 1;
		return {
			url: part.url[indx],
			enabled:false,
			videoReferenceInDom: part.videoReferenceInDom[indx],
			chapterManager: part.chapterManager[indx]
		}
	}
}